import styled from 'styled-components';
import { Horizontal } from 'common/common.styles';

export const Wrapper = styled(Horizontal)`
  > * {
    margin: 0 10px 0 0;
  }
`;
